export const ROUTES = {
  HOME: '/',
  DASHBOARD: '/dashboard',

  // Rota para visualizar componentes
  COMPONENTS: '/components', 
  COMPONENTS_BUTTONS: '/components/buttons',
  COMPONENTS_INPUTS: '/components/inputs',
  COMPONENTS_SELECTS: '/components/selects',
  COMPONENTS_CARDS: '/components/cards',
  COMPONENTS_MODALS: '/components/modals',
  COMPONENTS_TEXTAREA: '/components/textarea',
  COMPONENTS_BADGES: '/components/badges',
  COMPONENTS_TABLES: '/components/tables',
  COMPONENTS_FLOATING_TOOLBAR: '/components/floating-toolbar',
  
  // Páginas de erro
  ERRORS: {
    ERROR_404: '/404',
    ERROR_502: '/502', 
    ERROR_503: '/503',
  },

  // Demandas - estrutura base para futuras funcionalidades
  DEMANDS: {
    BASE: '/demands',
    LIST: '/demands',
    VIEW: (id: string = ':id', params?: { type?: string }) => {
      const path = `/demands/${id}/view`
      if (params?.type) {
        return `${path}?type=${params.type}`
      }
      return path
    },
    CREATE: '/demands/new',
    EDIT: (id: string = ':id') => `/demands/${id}/edit`,
  },

  // Configurações
  SETTINGS: {
    BASE: '/configuracoes',
    PROFILE: '/configuracoes/perfil',
    GENERAL: '/configuracoes/geral',
  },

  // Processos
  PROCESSES: {
    BASE: '/processos',
    CREATE: '/processos/novo',
    LIST: '/processos/lista',
    VIEW: (id: string = ':id') => `/processos/${id}`,
    EDIT: (id: string = ':id') => `/processos/${id}/editar`,
  },

  // Notificações
  NOTIFICATIONS: '/notificacoes',

  // Colaboradores
  COLLABORATORS: '/colaboradores',

  // Calendário
  CALENDAR: '/calendar',
} as const;
